import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { GoogleFreeBookingLinksSettingsHotelTypeSelectionModal } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchGoogleFreeBookingLinksSettingsHotelTypeSelectionModal = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(GoogleFreeBookingLinksSettingsHotelTypeSelectionModal, {
		variables: {
			hotelID,
		},
	});
};
